import { type MusicList } from '@clients/ContentApi';
import { toAbsoluteSrc } from '@store/content';

export default class SiteMusic {
    constructor(data: MusicList) {
        this.title = data.title ?? '';
        this.id = data.id;
        this.src = toAbsoluteSrc(data.file.url);
    }

    id: string;
    title: string;
    src: string;
}
